module.exports = __webpack_public_path__ + "img/hilton-res.9e010dff.jpg";